import { useStore } from '@nanostores/react';
import { atom } from 'nanostores';
import { useQueryState } from 'nuqs';

type Modal = {
  isOpen: boolean;
};

export function createModal(
  name: string,
  {
    type = 'ephemeral',
  }: {
    type?: 'url' | 'ephemeral';
  } = {},
): () => {
  isOpen: boolean;

  show: () => Promise<void>;
  close: () => Promise<void>;
  toggle: () => Promise<void>;
} {
  if (type === 'ephemeral') {
    const $modal = atom<Modal>({ isOpen: false });

    return function useEphemeralModal() {
      const modal = useStore($modal);
      return {
        isOpen: modal.isOpen,
        show: async () => {
          $modal.set({ isOpen: true });
        },
        close: async () => {
          $modal.set({ isOpen: false });
        },
        toggle: async () => {
          $modal.set({ isOpen: !modal.isOpen });
        },
      };
    };
  } else {
    return function useUrlModal() {
      const [modal, setModal] = useQueryState('modal');

      const isOpen = modal === name;

      return {
        isOpen,
        show: async () => {
          setModal(name);
        },
        close: async () => {
          setModal(null);
        },
        toggle: async () => {
          if (isOpen) {
            setModal(null);
          } else {
            setModal(name);
          }
        },
      };
    };
  }
}
